"use client";

import * as React from "react";
import Image from "next/image";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@soonlist/ui/carousel";

const slides = [
  {
    src: "/app-store-screenshots/0.webp",
    alt: "Soonlist app store screenshot: Turn screenshots into plans",
  },
  {
    src: "/app-store-screenshots/1.webp",
    alt: "Soonlist app store screenshot: Save any event in one tap",
  },
  {
    src: "/app-store-screenshots/2.webp",
    alt: "Soonlist app store screenshot: Get all the details, no searching required",
  },
  {
    src: "/app-store-screenshots/3.webp",
    alt: "Soonlist app store screenshot: Organize all your options in one place",
  },
  {
    src: "/app-store-screenshots/4.webp",
    alt: "Soonlist app store screenshot: Share your Soonlist with friends",
  },
  {
    src: "/app-store-screenshots/5.webp",
    alt: "Soonlist app store screenshot: Add to your calendar, or sync it all",
  },
];

export function CarouselDemo() {
  return (
    <Carousel
      className="h-full w-full"
      opts={{
        align: "start",
        loop: false,
      }}
    >
      <CarouselContent>
        {slides.map((slide, index) => (
          <CarouselItem key={index}>
            <Image
              src={slide.src}
              alt={slide.alt}
              style={{ objectFit: "cover" }}
              priority={index === 0}
              height={1792}
              width={828}
              className="rounded-lg"
            />
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious />
      <CarouselNext />
    </Carousel>
  );
}
